import './NotFoundPage.scss';

function NotFoundPage() {

  return (
    <div className='not-found-container'>
      <h1>404</h1>
      <h2>Page Not Found</h2>
    </div>
  );
}

export default NotFoundPage
